import {
    BaseTaskListScenarioId,
    TaskListPickerDefaultMaxWidth,
    AssetContextMenuOffset,
} from '../constants';
import type { TaskListPayload } from '../schema/TaskListPayload';
import { getDefaultListId } from '../utils/getDefaultListId';
import { assertNever } from 'owa-assert';
import { useAssetId, usePatchPartialPayload } from 'owa-timestream-asset-sdk';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import * as React from 'react';
import {
    TodoListId,
    TodoListCallbackPayload,
    isTodoListUpdateListCallback,
    LoadPanelDataConfigType,
    LoadPanelDataConfig,
} from 'owa-todo-list-types';
import { useElementSizeTracker } from 'owa-react-hooks/lib/useElementSizeTracker';

// TODO VSO 93133: handle when loaded task list view asset has a folderid that has been deleted
export default function useTaskListAssetViewState({
    payload,
}: AssetCommonViewProps<TaskListPayload>) {
    const scenarioId = BaseTaskListScenarioId + '-' + useAssetId();
    const patchPartialPayload = usePatchPartialPayload<TaskListPayload>();
    const patchFolderId = React.useCallback(
        (listId: TodoListId) => {
            patchPartialPayload({
                listId: listId,
            });
        },
        [patchPartialPayload, payload.listId]
    );
    const onCallback = (payload: TodoListCallbackPayload) => {
        if (isTodoListUpdateListCallback(payload)) {
            patchFolderId(payload.listId);
        } else {
            assertNever(payload);
        }
    };

    const containerRef = React.useRef<HTMLDivElement | null>(null);
    const [containerRect] = useElementSizeTracker(containerRef);

    const taskListPickerMaxWidth = containerRect
        ? containerRect.width - AssetContextMenuOffset
        : TaskListPickerDefaultMaxWidth;

    const loadPanelDataConfig: LoadPanelDataConfig = {
        type: LoadPanelDataConfigType.ListId,
        listId: payload.listId ?? getDefaultListId(),
    };
    return {
        scenarioId,
        patchFolderId,
        onCallback,
        loadPanelDataConfig,
        containerRef,
        taskListPickerMaxWidth,
    };
}
